//Import
import React, { useContext, useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import Select, { components } from 'react-select';
//Import Context
import { AppContext } from "../../../contexts/AppContext";
import { AuthContext } from "../../../contexts/AuthContext";
import staticData from '../../../contexts/staticData.json';
//Import Components
import ContainerSearch from "../addPME/ContainerSearch";
//Import Helpers
import { formatCurrency, getSubventionNames, formatDate, formatDisplayName, getStateLabel, getTypePurchase } from "../../../shared/helpers";
//Import Icons
import arrowSide from '../../../assets/icons/arrowSide.svg';
import downArrow from '../../../assets/icons/downArrowWhite.svg';
import search from '../../../assets/icons/searchWhite.svg';
//Import CSS
import './follow.css';

function FollowUp() {
    //UseContect
    const { dataProjects, establishmentList, requestsList, pmeList } = useContext(AppContext);
    const { userData } = useContext(AuthContext);
    //UseLocation - useNavigate
    const location = useLocation();
    const navigate = useNavigate();
    const { dataSearch } = location.state || {};
    //UseState
    const [view, setView] = useState(false);
    const [requests, setRequests] = useState(null);
    const [typeOfRequest, setTypeOfRequest] = useState(null);
    const [dataSearchFollowUp, setDataSearchFollowUp] = useState({
        region: dataSearch?.region || null,
        commune: dataSearch?.commune || null,
        holder: {
            value: dataSearch?.holder.value || null,
            id: dataSearch?.holder.id || null
        },
        establishment: {
            value: dataSearch?.establishment.value || null,
            id: dataSearch?.establishment.id || null
        },
    })

    useEffect(() => {
        const initializeEstablishmentData = () => {
            if (userData?.dimension === 'Establecimiento' && 
                userData.establishmentId && 
                userData.tenantId && 
                establishmentList && 
                dataProjects && 
                !dataSearchFollowUp.establishment.id) {
                
                const establishment = establishmentList.find(est => est.id === userData.establishmentId);
                const holder = dataProjects.find(project => project.id === userData.tenantId);
                if (establishment && holder) {
                    setDataSearchFollowUp(prevState => ({
                        ...prevState,
                        establishment: { 
                            value: establishment.nameEstablishment, 
                            id: establishment.id 
                        },
                        holder: { 
                            value: holder.nameProject, 
                            id: holder.id 
                        }
                    }));
                }
            }
        };
        initializeEstablishmentData();
    }, [userData, establishmentList, dataProjects]);
    
    useEffect(() => {
        if (dataSearchFollowUp.establishment?.id) {
            const filteredRequests = requestsList.filter(request =>
                request.idEstablishment === dataSearchFollowUp.establishment.id
            );
            setRequests(filteredRequests);
            setView(true);
        }
    }, [dataSearchFollowUp.establishment?.id, requestsList]);

    const getRequestDetails = (req) => {
        if (req.typeOfRequest === 'payment') {
            return {
                folio: req.folio || 'N/A',
                requestAmount: req.amountToBePaid || 0,
                created: req.created,
                state: req.state,
                typeOfRequest: req.typeOfRequest
            };
        } else {
            return {
                folio: req.requestDetails?.folio || 'N/A',
                requestAmount: req.requestDetails?.requestAmount || 0,
                created: req.requestDetails?.created || null,
                state: req.requestDetails?.state || 'unknown',
                typeOfRequest: req.typeOfRequest,
                requestDetails: req.requestDetails
            }
        }
    };

    const handleSelect = (selectedOption, { name }) => {
        const value = selectedOption ? selectedOption.value : null;
        const id = selectedOption ? selectedOption.id : null;
        setDataSearchFollowUp(prevState => ({
            ...prevState,
            [name]: name === 'holder' || name === 'establishment'
                ? { value, id }
                : value,
            ...(name === 'region' && { commune: null, holder: { value: null, id: null }, establishment: null }),
            ...(name === 'commune' && { holder: { value: null, id: null }, establishment: null }),
            ...(name === 'holder' && { establishment: null })
        }));
        setView(false);
    };

    const handleButtonClick = () => {
        if (dataSearchFollowUp.establishment && dataSearchFollowUp.establishment.id) {
            const filteredRequests = requestsList.filter(request =>
                request.idEstablishment === dataSearchFollowUp.establishment.id
            );
            setRequests(filteredRequests);
            setView(true);
        }
    };

    const handleClickSearch = (e) => {
        e.preventDefault();
        if (typeOfRequest) {
            let filteredRequests = requestsList.filter(request =>
                request.idEstablishment === dataSearchFollowUp.establishment.id
            );
            if (typeOfRequest.value !== 'all') {
                filteredRequests = filteredRequests.filter(request =>
                    request.typeOfRequest === typeOfRequest.value
                );
            }
            setRequests(filteredRequests);
        }
    };

    const findActivityDetails = (idActivity, idPME) => {
        const pme = pmeList.find(pme => pme.id === idPME);
        if (pme && pme.activities) {
            const activity = pme.activities.find(act => act.id == idActivity);
            if (activity) {
                return {
                    name: activity.nameOfAction,
                    subvention: activity.subsidies
                };
            }
        }
        return { name: 'No encontrado', subvention: 'No encontrado' };
    };

    const handleRequestClick = (request) => {
        const establishment = dataSearchFollowUp.establishment.value;
        // Aseguramos que la estructura del state sea correcta
        const navigationState = {
            establishment,
            returnState: {
                previousPath: location.pathname,
                dataSearch: dataSearchFollowUp
            }
        };
        if(request.typeOfRequest === 'payment') {
            navigate(`/establecimiento/seguimiento-pago/${request.id}`, {
                state: navigationState
            });
        } else {
            navigate(`/establecimiento/seguimiento/${request.id}`, {
                state: navigationState
            });
        }
        
    };


    return (
        <section className='follow-up-container flex'>
            <ContainerSearch
                dataSearch={dataSearchFollowUp}
                setDataSearch={setDataSearchFollowUp}
                handleSelect={handleSelect}
                handleButtonClick={handleButtonClick}
                dataProjects={dataProjects}
                establishmentList={establishmentList}
            />
            <section className='result-container flex'>
                {(view && requests) ? (
                    <>
                        {dataSearchFollowUp.establishment?.value && (
                            <article className='info-establishment flex'>
                                <h3>{dataSearchFollowUp.establishment.value}</h3>
                                <img src={arrowSide} className='icon' alt='Icono de flecha' />
                                <p>Seguimiento de Solicitudes</p>
                            </article>
                        )}
                        <article className='results-of-requests flex'>
                            <article className='filter-box flex'>
                                <span className='box-select'>
                                    <label className='label-hidden' htmlFor='typeOfRequest'>Tipo de Solicitud</label>
                                    <Select
                                        name='typeOfRequest'
                                        id='typeOfRequest'
                                        options={staticData.typeOfRequestOptions}
                                        placeholder='Selecciona tipo de solicitud'
                                        className='custom-select'
                                        classNamePrefix='custom-select'
                                        components={{ DropdownIndicator }}
                                        value={typeOfRequest}
                                        onChange={(selectedOption) => setTypeOfRequest(selectedOption)}
                                    />
                                </span>
                                <button className='box-button flex' onClick={handleClickSearch}>
                                    <p>Filtrar Solicitudes</p>
                                    <img src={search} className='icon' alt='Icono para buscar solicitudes filtradas.' />
                                </button>
                            </article>
                            <article className='results-table-container'>
                                <table className='results-table'>
                                    <thead>
                                        <tr>
                                            <td>Folio</td>
                                            <td>Tipo de Solicitud</td>
                                            <td>Nombre de la Acción</td>
                                            <td>Subvención</td>
                                            <td>Monto Solicitud</td>
                                            <td>Fecha Solicitud</td>
                                            <td>Estado</td>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {(requests && requests.length > 0) ? (requests
                                            .sort((a, b) => {
                                                const detailsA = getRequestDetails(a);
                                                const detailsB = getRequestDetails(b);
                                                return detailsB.created?.seconds - detailsA.created?.seconds;
                                            })
                                            .map((req) => {
                                                const activityDetails = findActivityDetails(req.idActivity, req.idPME);
                                                const details = getRequestDetails(req);
                                                return (
                                                    <tr key={req.id} onClick={() => handleRequestClick(req)}>
                                                        <th data-label='Folio'>{details.folio}</th>
                                                        <th data-label='Tipo de Solicitud'>{getTypePurchase(details.typeOfRequest)}</th>
                                                        <th data-label='Nombre de la Acción'>{formatDisplayName(activityDetails.name)}</th>
                                                        <th data-label='Subvención'>{getSubventionNames(activityDetails.subvention)}</th>
                                                        <th data-label='Monto Solicitud'>{formatCurrency(details.requestAmount)}</th>
                                                        <th data-label='Fecha Solicitud'>{formatDate(details.created)}</th>
                                                        <th data-label='Estado'>
                                                            <p className={details.state}>{getStateLabel(details.state)}</p>
                                                        </th>
                                                    </tr>
                                                )
                                            })) : (
                                            <tr>
                                                <td colSpan='7'>No existen solicitudes para este filtro</td>
                                            </tr>
                                        )}
                                    </tbody>
                                </table>
                            </article>

                        </article>

                    </>
                ) : (
                    <p className='text-bold message-not-found flex'>No existen solicitudes creadas por este colegio</p>
                )}
            </section>
        </section>
    )
};

const DropdownIndicator = (props) => {
    return (
        <components.DropdownIndicator {...props}>
            <img src={downArrow} alt="CustomArrow" />
        </components.DropdownIndicator>
    );
};

export default FollowUp;